import styled from 'styled-components'

import { InputContainer as DefaultInputContainer } from '../../Shared'

export const InputContainer = styled(DefaultInputContainer)`
	min-width: 34px;
	max-width: 36px;
	min-height: 46px;
	padding: 8px 6px;
	margin: 0;
	width: fit-content;
`
